export const BOTIMZA_BASE_URL = 'https://www.botimza.com';
export const BOTIMZA_QUERY_PARAM = 'q';
export const REF_QUERY_PARAM = 'r';
export const REF_SHARE_BUTTON = 'btn';
export const REF_TELEGRAM_MSG = 'pst';
export const REF_INFO_PAGE = 'info';
// Internal cross-links between search/info pages themselves (RelatedGuides,
// RelatedSearches, PopularSearches, the /search hub) - docs/ssr-seo-distribution-plan.md
// Phase 3 item 5. Distinguishes organic on-site discovery from Telegram/Facebook/info-page
// referrals in Mixpanel's "Page View" referrer breakdown.
export const REF_RELATED_SEARCH = 'rel';

// Allowlist of event names client code (StatsWrapper.js) may report via
// POST /api/stats/track. Once that endpoint is unauthenticated-reachable, an
// arbitrary client-supplied eventName would let anyone register unbounded
// unique names in statEventTypes forever - see
// docs/stats-mixpanel-migration-plan.md Sec5. Grows as client call sites are
// migrated to the new stats system.
export const STATS_ALLOWED_EVENT_NAMES = [
  // Auth flow (Botimza/src/components/auth/AuthModal.jsx, Botimza/src/utils/userUtils.js).
  // Deliberately no email/reason/error properties on any of these - accountId
  // already ties a success event to the logged-in trackerId server-side, and
  // email is PII with no analytical need that outweighs the minimal-schema
  // design goal (docs/stats-mixpanel-migration-plan.md Sec5/Sec8 task 6).
  'auth.login.success',
  'auth.login.failed',
  'auth.registration.success',
  'auth.registration.failed',
  'auth.google_login.success',
  'auth.google_login.failed',
  'auth.logout.success',
  'auth.logout.failed',

  // Page views (Hero.jsx via App.jsx routing, SearchResultsPage.jsx SSR
  // hydration path). Same event name/shape server.js's referrer canary uses.
  'page.view',

  // Search & tracking flow (Hero.jsx, SearchResults.jsx, TrackItemModal.jsx,
  // UpdateTargetPriceModal.jsx, MyTrackingPage.jsx).
  'search',
  'search.share_link',
  'search.variants_clicked',
  'tracking.set',
  'tracking.updated',
  'tracking.target_price_update_attempted',
  'tracking.target_price_updated',
  'tracking.my_tracking_fetched',
  'tracking.stopped',
  'tracking.my_tracking_page_viewed',

  // Item card / modal events (ProductCard.jsx, ItemFullscreenModal.jsx,
  // NewAmazonCard.jsx, AliExpressAdCard.jsx).
  'item.track_button_clicked',
  'item.enlarge_clicked',
  'item.purchase_link_clicked',
  'item.fullscreen_opened',
  'item.purchase_link_clicked_fullscreen',
  'item.new_amazon_support_clicked',
  'item.aliexpress_ad_clicked',
  // My Tracking page's shop button/image (TrackedItemCard.jsx) - previously
  // untracked entirely, even under Mixpanel (see AmazonLink.jsx).
  'item.purchase_link_clicked_my_tracking',

  // Remaining misc events (banners, dismiss-modals, terms page, App.jsx's
  // route-change page view tracker).
  'banner.amazon_community_clicked',
  'banner.missing_domain_clicked',
  'modal.instructions_dont_show_again',
  'modal.vat_info_dont_show_again',

  // Local Amazon scraper ops metric (services/pageScraper/pageScrapeService.js),
  // reported over the same public ingestion endpoint the browser client uses -
  // not a user-facing event, no associated accountId.
  'scraper.pages_scraped',

  // Post-click-out follow-up popup (DealFollowupPopup.jsx) - see
  // docs/deal-signal-design.md §6/§9/§10. The popup's own order-status and
  // deal-quality answers go to the dedicated /api/deal-followup/answer
  // endpoint instead (dealFollowupRoutes.js), not this generic one - only
  // the Facebook-group share tap remains a plain stat event here.
  'deal.share_group_clicked',
];


